import { FormGroup } from '@angular/forms';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { addRemoveError } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { isEqual } from 'lodash-es';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import {
    MyAllElemRevisoriControlloContabileEntity,
    MySpmElemComitatoGestioneEntity,
} from '../../../../models/interfaces/revisione.interface';
import {
    getNormeSpaMonisticoControl,
    getAmmControlloControl,
    checkCkNormeValue,
    normeSpaMonisticoRequiredHelper,
    setRequiredIfNormeActiveAndSecondFilled,
} from './helpers/norme-spa-monistico-form-validators.helper';

const SPM_COMIT_GEST_PATH = 'my_NormeSpaMonistico.my_SpmComitatoGestione.my_SpmElemComitatoGestione';

export const normeSpaMonisticoOrganoControlloRules: FormGroupRules = {
    my_CkSpmComitGestConsAmmin: (form: FormGroup) => {
        setRequiredIfNormeActiveAndSecondFilled(form, 'my_NormeSpaMonistico.my_CkSpmComitGestConsAmmin', SPM_COMIT_GEST_PATH);
    },

    my_CkSpmCompStatoInOrgContr: (form: FormGroup) => {
        setRequiredIfNormeActiveAndSecondFilled(form, 'my_NormeSpaMonistico.my_CkSpmCompStatoInOrgContr', SPM_COMIT_GEST_PATH);
    },

    my_CkSpmCompRevisori: (form: FormGroup) => {
        setRequiredIfNormeActiveAndSecondFilled(form, 'my_NormeSpaMonistico.my_CkSpmCompRevisori', SPM_COMIT_GEST_PATH);
    },

    my_CkSpmCompRelazionano: (form: FormGroup) => {
        setRequiredIfNormeActiveAndSecondFilled(form, 'my_NormeSpaMonistico.my_CkSpmCompRelazionano', SPM_COMIT_GEST_PATH);
    },

    my_SpmNoteComposComitGest: (form: FormGroup) => {
        setRequiredIfNormeActiveAndSecondFilled(form, 'my_NormeSpaMonistico.my_SpmNoteComposComitGest', SPM_COMIT_GEST_PATH);
    },

    my_lblSpmContrCont: (form: FormGroup) => {
        const my_lblSpmContrContControl = getNormeSpaMonisticoControl(form, 'my_lblSpmContrCont');
        const my_lblSpmContrCont: string = my_lblSpmContrContControl.value;
        const my_SpmElemComitatoGestione: MySpmElemComitatoGestioneEntity[] = getNormeSpaMonisticoControl(
            form,
            'my_SpmComitatoGestione.my_SpmElemComitatoGestione'
        ).value;
        const errors = my_lblSpmContrContControl.errors ?? {};

        addRemoveError(checkCkNormeValue(form) && my_lblSpmContrCont === '6' && isNilOrEmpty(my_SpmElemComitatoGestione), errors, 'my_lblSpmContrCont', {
            status: 'Il Comitato di Controllo sulla Gestione è obbligatorio quando gli è stato affidato il Controllo contabile',
        });

        addRemoveError(checkCkNormeValue(form) && isNilOrEmpty(my_lblSpmContrCont) && !isNilOrEmpty(my_SpmElemComitatoGestione), errors, 'my_lblSpmContrCont', {
            status: REQUIRED_STATUS,
        });

        my_lblSpmContrContControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSpmAffidamContrCont: (form: FormGroup) => {
        const my_CkSpmAffidamContrContControl = getNormeSpaMonisticoControl(form, 'my_CkSpmAffidamContrCont');
        const my_CkSpmAffidamContr: string = my_CkSpmAffidamContrContControl.value;
        const my_AllElemRevisoriControlloContabile: MyAllElemRevisoriControlloContabileEntity[] = getAmmControlloControl(
            form,
            'my_AllRevisoriControlloContabile.my_AllElemRevisoriControlloContabile'
        ).value;
        const errors = my_CkSpmAffidamContrContControl.errors ?? {};

        addRemoveError(checkCkNormeValue(form) && my_CkSpmAffidamContr === '3' && my_AllElemRevisoriControlloContabile?.length <= 1, errors, 'my_CkSpmAffidamContrCont', {
            status: 'Inserire i revisori esterni',
        });

        addRemoveError(checkCkNormeValue(form) && my_CkSpmAffidamContr === '2' && my_AllElemRevisoriControlloContabile?.length !== 1, errors, 'my_CkSpmAffidamContrCont', {
            status: 'Inserire un revisore esterno',
        });

        addRemoveError(checkCkNormeValue(form) && isNilOrEmpty(my_CkSpmAffidamContr), errors, 'my_CkSpmAffidamContrCont', {
            status: REQUIRED_STATUS,
        });

        my_CkSpmAffidamContrContControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_SpmNoteComposOrgContr: (form: FormGroup) => {
        normeSpaMonisticoRequiredHelper(form, 'my_NormeSpaMonistico.my_SpmNoteComposOrgContr');
    },
};
